import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ResponsiveBanner extends Component {
  constructor(props) {
    super(props);
    this.setImage = this.setImage.bind(this);
    this.state = {
      src: ''
    };
  }

  setImage(e) {
    let src = '';
    // Old browser
    if (typeof e.target.currentSrc === "undefined") {
      src = e.target.src;
    }
    // Modern browser
    else {
      src = e.target.currentSrc;
    }
    this.setState({
      src,
    });
  }

  render() {
    const {
      src,
    } = this.state;

    const {
      desktop,
      mobile,
      tablet
    } = this.props;

    return (
      <div
        style={{
          backgroundImage: `url(${src})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '300px'
        }}
      >
        <picture className='d-none'>
          <source
            media="(max-width: 576px)"
            srcSet={mobile}/>
          <source
            media="(max-width: 768px)"
            srcSet={tablet}/>
          <img
            onLoad={this.setImage}
            src={desktop}
            />
        </picture>
      </div>
    );
  }
}

ResponsiveBanner.propTypes = {
  desktop: PropTypes.string.isRequired,
  tablet: PropTypes.string.isRequired,
  mobile: PropTypes.string.isRequired,
};

export default ResponsiveBanner;



// WEBPACK FOOTER //
// ./src/Common/ResponsiveBanner.js